import {
  type GetWorkerRequirementsResponse,
  WorkerRequirementMappingLevel,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { type UseInfiniteGetQueryOptions } from "@src/appV2/api/useInfiniteGetQuery";
import { type AxiosError } from "axios";

import { type WorkerRequirement } from "../types";
import { useGetPaginatedWorkerRequirements } from "../useGetPaginatedWorkerRequirements";
import { requirementRelationship } from "../useGetWorkerRequirements";

interface UseGetCompletedWorkplaceSpecificRequirementsProps {
  qualifications: string[];
}

export function useGetCompletedWorkplaceSpecificRequirements(
  props: UseGetCompletedWorkplaceSpecificRequirementsProps,
  options: UseInfiniteGetQueryOptions<
    GetWorkerRequirementsResponse,
    AxiosError,
    WorkerRequirement[]
  > = {}
) {
  const { qualifications } = props;

  return useGetPaginatedWorkerRequirements(
    {
      filter: {
        qualifications,
        requiredForBooking: true,
        // todo: should we change this to 'workplaces' in bff?
        levels: [WorkerRequirementMappingLevel.HCF],
        status: { in: [WorkerRequirementStatus.APPROVED] },
        visibleToWorker: true,
      },
      include: [...requirementRelationship],
      page: { size: 10 },
    },
    options
  );
}
